export const login = async (password) => {
  try {
    const response = await fetch(
      "https://z8k6186qa0.execute-api.us-east-1.amazonaws.com/login",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { success: true, expiresAt: data.expiresAt };
    } else {
      return { success: false, message: data.message || "Incorrect password" };
    }
  } catch (error) {
    return { success: false, message: "Network error" };
  }
};
